import { render, staticRenderFns } from "./ViewDocumentRegion.vue?vue&type=template&id=4460dde1&"
import script from "./ViewDocumentRegion.vue?vue&type=script&lang=js&"
export * from "./ViewDocumentRegion.vue?vue&type=script&lang=js&"
import style0 from "./ViewDocumentRegion.vue?vue&type=style&index=0&id=4460dde1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports